import './AbstractiveView.css';

const AbstractiveView = () => {
    return (
        <div
            className='abstract'>
            <p>
                ❗ Disclaimer ❗ <br />
                Here you'll get to know about me and my work in a more detail. Hope I manage to surprise you.<br />....obviously in a good way.
            </p>

        </div>
    )
}

export default AbstractiveView;